const LEGACY_ZONE_ID_MAPPING = {
    'Africa/Asmera': 'Africa/Asmara',
    'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
    'America/Catamarca': 'America/Argentina/Catamarca',
    'America/Cordoba': 'America/Argentina/Cordoba',
    'America/Fort_Wayne': 'America/Indiana/Indianapolis',
    'America/Godthab': 'America/Nuuk',
    'America/Indianapolis': 'America/Indiana/Indianapolis',
    'America/Jujuy': 'America/Argentina/Jujuy',
    'America/Kralendijk': 'America/Curacao',
    'America/Louisville': 'America/Kentucky/Louisville',
    'America/Lower_Princes': 'America/Curacao',
    'America/Marigot': 'America/Port_of_Spain',
    'America/Mendoza': 'America/Argentina/Mendoza',
    'America/Santa_Isabel': 'America/Tijuana',
    'America/St_Barthelemy': 'America/Port_of_Spain',
    'Antarctica/South_Pole': 'Antarctica/McMurdo',
    'Arctic/Longyearbyen': 'Europe/Oslo',
    'Asia/Calcutta': 'Asia/Kolkata',
    'Asia/Chungking': 'Asia/Chongqing',
    'Asia/Katmandu': 'Asia/Kathmandu',
    'Asia/Rangoon': 'Asia/Yangon',
    'Asia/Saigon': 'Asia/Ho_Chi_Minh',
    'Atlantic/Faeroe': 'Atlantic/Faroe',
    'Europe/Bratislava': 'Europe/Prague',
    'Europe/Busingen': 'Europe/Zurich',
    'Europe/Mariehamn': 'Europe/Helsinki',
    'Europe/Podgorica': 'Europe/Belgrade',
    'Europe/San_Marino': 'Europe/Rome',
    'Europe/Vatican': 'Europe/Rome',
    'Pacific/Ponape': 'Pacific/Pohnpei',
    'Pacific/Truk': 'Pacific/Chuuk',
    'Pacific/Yap': 'Pacific/Chuuk',
    'US/East-Indiana': 'America/Indiana/Indianapolis',
    Z: 'UTC'
};
export function guessUserTimeZone() {
    const guessedZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    return LEGACY_ZONE_ID_MAPPING[guessedZoneId] || guessedZoneId;
}
//# sourceMappingURL=utils.js.map